import { ForgeModule } from '@tylertech/forge-angular';

import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe, Location } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MeetingManagerComponent } from './meeting-manager/meeting-manager.component';
import { FormsModule } from '@angular/forms';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ViewMeetingComponent } from './lib/popup/view-meeting/view-meeting.component';
import { SharedMeetingManagerModule } from '../shared-meeting-manager/shared-meeting-manager.module';
import { SharedCommonService } from '../shared/services/shared-common.service';
import { ViewMeetingMapping } from './lib/mapping/view-meeting-mapping';
import { SafeHtmlURLPipe } from '../shared/common/pipes/safe-html.pipe';
import { MeetingManagerRoutingModule } from './meeting-manager.routes';
import { SearchResultComponent } from './search-result/search-result.component';
import { BadgeWithCloseComponent } from './badge-with-close/badge-with-close.component';
import { ForgeComponents } from 'app/forge-components';
import { BoardsComponent } from './boards/boards.component';
import { ProfilePictureComponent } from './lib/profile-picture/profile-picture.component';
import { SubscribeDialogComponent } from './lib/subscribe-dialog/subscribe-dialog.component';
import { GoogleDisclosureComponent } from './google-disclosure/google-disclosure.component';

@NgModule({
    imports: [
        MeetingManagerRoutingModule,
        CommonModule,
        SharedModule,
        FormsModule,
        FullCalendarModule,
        SharedMeetingManagerModule,
        ForgeModule,
        ForgeComponents
    ],
    declarations: [
        MeetingManagerComponent, ViewMeetingComponent, SearchResultComponent, BadgeWithCloseComponent, BoardsComponent, ProfilePictureComponent, SubscribeDialogComponent, GoogleDisclosureComponent
    ],
    providers: [
        Location,
        SharedCommonService,
        ViewMeetingMapping,
        SafeHtmlURLPipe,
        DatePipe
    ],
    exports: [
        ForgeModule
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class MeetingManagerModule {
    constructor() {

    }
}
